import { ArticleHeading1, Image, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import { DealSalePromoChip } from '../../../../components/DealSalePromoChip';
import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../../../constants/mediaQueries';

import * as styles from './styles.css';

export const DealStepModalHeadingSection: React.FC<{
  imageX1: string;
  imageX2: string;
  chip: string;
  title: string;
  subtitle: string;
}> = props => {
  return (
    <div className={styles['heading-section']}>
      <Image
        width={140}
        height={100}
        loading="lazy"
        src={props.imageX1}
        sources={[{ srcset: props.imageX2, media: X2_IMAGE_SIZE_MEDIA_QUERY }, { srcset: props.imageX1 }]}
      />
      <div className={styles['chip']}>
        <DealSalePromoChip>{props.chip}</DealSalePromoChip>
      </div>
      <div className={styles['title']}>
        <ArticleHeading1 as="h4">{props.title}</ArticleHeading1>
      </div>
      <UIText1>{props.subtitle}</UIText1>
    </div>
  );
};
